import * as z from "zod";

const armStats = z.object({
  arm: z.enum(["imessage", "sms_forced"]),
  enrolledCustomers: z.number(),
  dispatchesSent: z.number(),
  dispatchesViaImessage: z.number(),
  dispatchesViaSms: z.number(),
  customersWithReply: z.number(),
  replyCount: z.number(),
  revenue: z.number(),
  returnCost: z.number(),
  netLtv: z.number(),
  avgNetLtvPerCustomer: z.number(),
  exchangesCount: z.number(),
  /** ISO currency code for the money fields, or null if mixed/no data. */
  revenueCurrency: z.string().nullable(),
});

/** Handler derives the window from `[startedAt, endedAt ?? now]`. */
export const getIMessageChannelExperimentAnalytics = {
  name: "getIMessageChannelExperimentAnalytics" as const,
  input: z.object({ testId: z.string() }),
  output: z.object({
    totalEnrolled: z.number(),
    /** LTV covers fewer customers than `totalEnrolled` (scan capped or Mongo failed). */
    ltvTruncated: z.boolean(),
    imessage: armStats,
    smsForced: armStats,
    /** Global IMESSAGE_CHANNEL_AB_TEST LD flag. Off → resolver refuses to enroll. */
    ldFlagEnabled: z.boolean(),
    /** The test's window — `null` end means "still running". */
    windowStart: z.date(),
    windowEnd: z.date().nullable(),
  }),
};
